import script from "./supplier.vue?vue&type=script&setup=true&lang=ts"
export * from "./supplier.vue?vue&type=script&setup=true&lang=ts"

import "./supplier.vue?vue&type=style&index=0&id=63b6b6de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63b6b6de"]])

export default __exports__